import * as React from 'react';

import { FormattedMessage, InjectedIntlProps  } from 'react-intl';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router';
import { formValueSelector } from 'redux-form';

import { registerProfile } from 'actions/account';
import { Button } from 'components/Button';
import { Form } from 'components/Form';
import { FieldFileCard, InputFileCard } from 'components/Input';
import { InputFileImage } from 'components/Input/InputFile/InputFile';
import { LayoutHeader } from 'components/Layout';
import { APPLICATION_FORM_NAME, ROUTE_ACCOUNT_KYC_REGISTER } from 'constants/app';
import { injectIntl } from 'helper/redux';
import { validate } from 'helper/validation/account/accountKycUploadDocumentForm';
import { ImageNationalCardScan, ImageNationalCardSelfie } from 'images/index';
import { AccountKycUploadDocumentForm, AccountProfileForm } from 'models/account';
import { AppState } from 'models/app';

import './AccountKycUploadDocument.scss';

interface StateProps {
  nationalCardScanFormValue: InputFileImage;
  nationalCardSelfieFormValue: InputFileImage;
  tempAccountProfile: AccountProfileForm;
}

interface DispatchProps {
  registerProfile: typeof registerProfile;
}

type OwnProps = InjectedIntlProps & RouteComponentProps<{}>;

type AccountKycUploadDocumentProps = StateProps & DispatchProps & OwnProps;

const selector = formValueSelector(APPLICATION_FORM_NAME);

@injectIntl()
class AccountKycUploadDocumentContainer extends React.Component<AccountKycUploadDocumentProps, {}> {
  constructor(props: AccountKycUploadDocumentProps) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }

  render() {
    const { history, intl, tempAccountProfile } = this.props;

    if (!tempAccountProfile || !tempAccountProfile.name) {
      return <Redirect to={ROUTE_ACCOUNT_KYC_REGISTER}/>;
    }

    return (
      <Form
        className="o-container o-container--fluid o-container--fluid-vertical"
        form={APPLICATION_FORM_NAME}
        onSubmit={this.onSubmit}
        validate={validate}
      >
        <LayoutHeader actionIcon="ic-arrow-left" actionHandler={history.goBack}>
          <h1 className="o-layout-header-title"><FormattedMessage id="account.kyc.uploadDocument.title"/></h1>
        </LayoutHeader>
        <p><FormattedMessage id="account.kyc.uploadDocument.subtitle"/></p>

        <FieldFileCard
          className="account-kyc-upload-document__upload-card"
          component={InputFileCard}
          imageSrc={ImageNationalCardScan}
          label={intl.formatMessage({ id: 'account.kyc.uploadDocument.nationalCardScan' })}
          name="nationalCardScan"
        />
        <FieldFileCard
          className="account-kyc-upload-document__upload-card"
          component={InputFileCard}
          imageSrc={ImageNationalCardSelfie}
          label={intl.formatMessage({ id: 'account.kyc.uploadDocument.nationalCardSelfie' })}
          name="nationalCardSelfie"
        />
        {this.actionButton}
      </Form>
    );
  }

  get actionButton() {
    const { nationalCardScanFormValue, nationalCardSelfieFormValue } = this.props;
    const isShowActionButton = nationalCardScanFormValue && nationalCardScanFormValue.preview
      && nationalCardSelfieFormValue && nationalCardSelfieFormValue.preview;
    if (isShowActionButton) {
      return (
        <Button type="submit" className="o-form-button button--full button--primary">
          <FormattedMessage id="account.kyc.uploadDocument.button"/>
        </Button>
      );
    }
    return null;
  }

  private onSubmit(formValue: AccountKycUploadDocumentForm) {
    this.props.registerProfile(formValue);
  }
}

export const AccountKycUploadDocument = connect<StateProps, DispatchProps, OwnProps>(
  (state: AppState) => ({
    nationalCardScanFormValue: selector(state, 'nationalCardScan'),
    nationalCardSelfieFormValue: selector(state, 'nationalCardSelfie'),
    tempAccountProfile: state.accountState.tempAccountProfileForm
  }), { registerProfile }
)(AccountKycUploadDocumentContainer);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Account/Kyc/AccountKycUploadDocument/AccountKycUploadDocument.tsx